import Spinner from '~/components/Spinner'
import Typography from '~/components/Typography'

import styles from './TotalRewardsBalance.pcss'
import { getFormattedSISValue } from './utils'
import { Rewards } from '~/pages/CrossChainFarmPage/types'

interface Props {
	children: React.ReactNode
	pending: boolean
	totalRewards?: Rewards
}

function TotalRewardsBalance({ children, pending, totalRewards }: Props) {
	return (
		<div className={styles.container}>
			<Typography
				className={styles.title}
				size="M"
				tag="div"
				color="gray"
			>
				Total available to claim:
			</Typography>

			{pending ? (
				<Spinner className={styles.spinner} />
			) : (
				<Typography className={styles.value} size="XL" tag="div">
					{getFormattedSISValue(totalRewards?.totalAvailableToClaim)}
				</Typography>
			)}

			{/*<br />*/}
			{/*<Typography*/}
			{/*	className={styles.title}*/}
			{/*	size="M"*/}
			{/*	tag="div"*/}
			{/*	color="gray"*/}
			{/*>*/}
			{/*	Total rewards vested:*/}
			{/*</Typography>*/}
			{/**/}
			{/*{pending ? (*/}
			{/*	<Spinner className={styles.spinner} />*/}
			{/*) : (*/}
			{/*	<Typography className={styles.value} size="L" tag="div">*/}
			{/*		{getFormattedSISValue(totalRewards?.totalRewardsVested)}*/}
			{/*	</Typography>*/}
			{/*)}*/}

			<br />
			<Typography
				className={styles.title}
				size="M"
				tag="div"
				color="gray"
			>
				Total rewards claimed:
			</Typography>
			{pending ? (
				<Spinner className={styles.spinner} />
			) : (
				<Typography className={styles.value} size="L" tag="div">
					{getFormattedSISValue(totalRewards?.totalRewardsClaimed)}
				</Typography>
			)}

			{children}
		</div>
	)
}

export default TotalRewardsBalance
